import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { GatsbyImage } from 'gatsby-plugin-image';
import * as style from './SmallPost.module.scss';
import { datePostedGmtToString } from '../../utilities';

const SmallPost = (props) => {
  const {
    imgData,
    imgAlt,
    imgHoverTitle,
    category,
    categoryLink,
    title,
    lead,
    authorImgData,
    authorName,
    authorSlug,
    datePostedGmt,
    timeToRead,
    slug,
    tag,
    sustainability = false,
  } = props;

  const { t } = useTranslation();

  return (
    <div
      className={`${style.smallPost} ${
        sustainability ? style.sustainability : ''
      }`}
    >
      {imgData && imgData?.images && (
        <Link
          className={`clearLinkStyle d-block ${style.imgContainer}`}
          to={slug}
        >
          {!sustainability && tag && <div className={style.tag}>{tag}</div>}
          <GatsbyImage
            image={imgData}
            alt={imgAlt}
            title={imgHoverTitle}
            loading="eager"
          />
        </Link>
      )}
      <div className={style.postBody}>
        {!sustainability ? (
          <Link
            className={`clearLinkStyle d-block ${style.category}`}
            to={categoryLink}
          >
            {category}
          </Link>
        ) : (
          <p className={`clearLinkStyle d-block ${style.category}`}>
            {category}
          </p>
        )}
        <Link className="clearLinkStyle d-block" to={slug}>
          <div className={style.title}>{title}</div>
          <p className={style.lead}>
            {lead && (lead.length < 220 ? lead : `${lead?.slice(0, 220)}...`)}
          </p>
        </Link>
        <div className={style.authorSection}>
          {!sustainability && authorImgData && authorImgData?.images && (
            <Link to={authorSlug} className="clearLinkStyle d-block">
              <GatsbyImage
                image={authorImgData}
                className={style.authorPic}
                alt={authorName}
                title={authorName}
                loading="eager"
                style={{ borderRadius: '50%' }}
              />
            </Link>
          )}
          <div>
            {!sustainability && (
              <Link
                to={authorSlug}
                className={`${style.authorName} clearLinkStyle d-block`}
              >
                {authorName}
              </Link>
            )}
            <div className={style.timeToRead}>
              <span>{datePostedGmtToString(datePostedGmt)}</span>
              {!Number.isNaN(timeToRead) && (
                <>
                  <span> · </span>
                  <span>{t('articles.timeToRead', { timeToRead })}</span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SmallPost.defaultProps = {
  authorImgData: {},
  category: 'recommended',
  categoryLink: '/',
  imgAlt: 'post featured image',
  imgData: {},
  imgHoverTitle: '',
  tag: '',
  timeToRead: 10,
};

SmallPost.propTypes = {
  /** Featured image of a post (gatsby-image data). */
  imgData: PropTypes.any,
  /** Featured image alternative text. */
  imgAlt: PropTypes.string,
  /** Image title to display a tooltip on hover. */
  imgHoverTitle: PropTypes.string,
  /** Author's avatar image (gatsby-image data). */
  authorImgData: PropTypes.object,
  /** Author's name (first name + last name). */
  authorName: PropTypes.string.isRequired,
  /** Author's slug - the link to their page. */
  authorSlug: PropTypes.string.isRequired,
  /** Title of a post. */
  title: PropTypes.string.isRequired,
  /** Category of a post. */
  category: PropTypes.string,
  /** A link to a category page. */
  categoryLink: PropTypes.string,
  /** Approximate time to read (minutes). */
  timeToRead: PropTypes.number,
  /** Date when post has been published GMT (later converted to local time). */
  datePostedGmt: PropTypes.string.isRequired,
  /** Slug of the post to form a link to it */
  slug: PropTypes.string.isRequired,
  /** Post's Tag (like Featured) */
  tag: PropTypes.string,
};

export default SmallPost;
